import type { AppLocale } from './appLocale'
import { appLocaleToLandingPageLocale } from './appLocale'

export type LandingPageAppEnv = 'development' | 'staging' | 'production'

/** Marketing site origin for the given deploy tier (override wins when set). */
export function resolveLandingPageOrigin(
  appEnv: LandingPageAppEnv,
  originOverride?: string
): string {
  const trimmed = originOverride?.trim()
  if (trimmed) {
    return trimmed.replace(/\/$/, '')
  }
  switch (appEnv) {
    case 'development':
      return 'http://localhost:3000'
    case 'staging':
      return 'https://staging.lucimark.com'
    case 'production':
      return 'https://lucimark.com'
  }
}

/** Full landing URL with locale path (`/en` for English; default locale uses site root). */
export function buildLandingPageUrl(params: {
  appEnv: LandingPageAppEnv
  locale?: AppLocale
  originOverride?: string
}): string {
  const origin = resolveLandingPageOrigin(params.appEnv, params.originOverride)
  const landingLocale = params.locale != null
    ? appLocaleToLandingPageLocale(params.locale)
    : 'pt'
  if (landingLocale === 'en') {
    return `${origin}/en`
  }
  return origin
}
